/**
 * Preferências de UI persistidas por usuário (localStorage).
 *
 * Chave SCOPED por `userId` — invariante do projeto: em máquina compartilhada, a
 * preferência de um advogado não pode valer para o próximo que entrar. Sem
 * `userId` NÃO há chave, e nada é lido nem gravado: o prefixo puro é o nome
 * legado que versões anteriores gravaram global, e tocá-lo enquanto a identidade
 * não resolve é exatamente o vazamento entre contas que o escopo impede.
 *
 * Só o acesso ao storage mora aqui. A DERIVAÇÃO do estado é de cada hook — elas
 * diferem de propósito (o chat tem entrada forçada por deep-link e só pré-abre
 * no desktop; a visão dos autos cede a vez ao `?view=` da URL).
 */

export function chaveDePreferencia(
  prefixo: string,
  userId: string | undefined,
): string | null {
  return userId ? `${prefixo}:${userId}` : null;
}

export function lerPreferencia(chave: string | null): string | null {
  if (!chave) return null;
  try {
    return localStorage.getItem(chave);
  } catch {
    // localStorage indisponível (modo privado, quota) — sem preferência.
    return null;
  }
}

export function gravarPreferencia(chave: string | null, valor: string): void {
  if (!chave) return;
  try {
    localStorage.setItem(chave, valor);
  } catch {
    // Sem persistência — a escolha vale só para a sessão atual.
  }
}
